// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditPopup_deleteButton__y30sh","field":"EditPopup_field__Cr9cw","text":"EditPopup_text__PJvwb"};